import { render, staticRenderFns } from "./batch-pay-dialog.vue?vue&type=template&id=387d6101&scoped=true"
import script from "./batch-pay-dialog.vue?vue&type=script&lang=js"
export * from "./batch-pay-dialog.vue?vue&type=script&lang=js"
import style0 from "./batch-pay-dialog.vue?vue&type=style&index=0&id=387d6101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d6101",
  null
  
)

export default component.exports